/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { ReactComponent as HomeIcon } from '../../assets/svg/home.svg';
import { ReactComponent as CallIcon } from '../../assets/svg/call.svg';
import { ReactComponent as PeopleIcon } from '../../assets/svg/people.svg';
import { ReactComponent as SettingIcon } from '../../assets/svg/setting.svg';
import { ReactComponent as GalleryIcon } from '../../assets/svg/gallery.svg';
import { ReactComponent as ProfileIcon } from '../../assets/svg/profile.svg';
import { setActiveTab } from '../../redux/active-tabs/active-tab.action';

const SideNav = ({ activeTab, setActiveTab, userRole }) => {
  const history = useHistory();

  return (
    <div className='site-sidebar' id='siteSideBar'>
      <ul className='site-sidebar-item-list'>
        <li
          className={`site-sidebar-item ${
            activeTab === 'home' ? 'active' : ''
          }`}
          onClick={() => {
            setActiveTab('home');
            history.push('/index');
          }}
        >
          <a>
            <div className='icon'>
              <HomeIcon />
            </div>
            <label htmlFor=''>Home</label>
          </a>
        </li>
        <li
          className={`site-sidebar-item ${
            activeTab === 'contact' ? 'active' : ''
          }`}
          onClick={() => {
            setActiveTab('contact');
            history.push('/contact');
          }}
        >
          <a>
            <div className='icon'>
              <CallIcon />
            </div>
            <label htmlFor=''>Add</label>
          </a>
        </li>

        <li
          className={`site-sidebar-item ${
            activeTab === 'gallery' ? 'active' : ''
          }`}
          onClick={() => {
            setActiveTab('gallery');
            history.push('/gallery');
          }}
        >
          <a>
            <div className='icon'>
              <GalleryIcon />
            </div>
            <label htmlFor=''>Gallery</label>
          </a>
        </li>

        <li
          className={`site-sidebar-item ${
            activeTab === 'profile' ? 'active' : ''
          }`}
          onClick={() => {
            setActiveTab('profile');
            history.push('/profile');
          }}
        >
          <a>
            <div className='icon'>
              <ProfileIcon />
            </div>
            <label htmlFor=''>Profile</label>
          </a>
        </li>

        {userRole && userRole === 'Administrator' && (
          <>
            <li
              className={`site-sidebar-item ${
                activeTab === 'users' ? 'active' : ''
              }`}
              onClick={() => {
                setActiveTab('users');
                history.push('/users');
              }}
            >
              <a>
                <div className='icon'>
                  <PeopleIcon />
                </div>
                <label htmlFor=''>User</label>
              </a>
            </li>
            <li
              className={`site-sidebar-item ${
                activeTab === 'settings' ? 'active' : ''
              }`}
              onClick={() => {
                setActiveTab('settings');
                history.push('/setting');
              }}
            >
              <a>
                <div className='icon'>
                  <SettingIcon />
                </div>
                <label htmlFor=''>Add</label>
              </a>
            </li>
          </>
        )}
      </ul>
    </div>
  );
};

const mapStateToProps = ({
  activeTabReducer: { activeTab },
  authReducer: { userRole },
}) => ({
  activeTab: activeTab,
  userRole: userRole,
});

const mapDispatchToProps = (dispatch) => ({
  setActiveTab: (data) => dispatch(setActiveTab(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SideNav);
